import React, { useState, useEffect } from "react";
import mockData from "./mockData";
import {
  Typography,
  CircularProgress,
  Button,
  Card,
  CardMedia,
  CardHeader,
  CardContent,
  IconButton,
} from "@material-ui/core";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const useStyles = makeStyles({
  media: {
    paddingTop: "56.25%",
  },
});

const Pokemon = (props) => {
  const classes = useStyles();
  const { match, history } = props;
  const { params } = match;
  const { pokemonId } = params;
  const [PokemonData, setPokemonData] = useState(undefined);

  useEffect(() => {
    axios
      .get(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`)
      .then((respone) => {
        const { data } = respone;
        setPokemonData(data);
      })
      .catch(() => {
        setPokemonData(false);
      });
  }, [pokemonId]);

  const generatePokemonJSX = () => {
    const { id, name, height, weight, sprites, types } = PokemonData;
    const FullImageURL = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`;
    const { front_default } = sprites;
    return (
      <>
        <Card
          variant="elevation"
          raised
          style={{ maxWidth: "400px", margin: "auto" }}
        >
          <CardHeader
            style={{ textTransform: "capitalize" }}
            avatar={id+'.'}
            title={name}
            action={
              <IconButton>
                <MoreVertIcon />
              </IconButton>
            }
          />
          <CardMedia className={classes.media} image={FullImageURL} />
          <CardContent>
            <Typography align="center" variant="body2" component="p">
              Height: {height}
            </Typography>
            <Typography align="center" variant="body2" component="p">
              Weight: {weight}
            </Typography>
          </CardContent>
          <Typography
            align="center"
            variant="h5"
            gutterBottom
            style={{ textTransform: "capitalize" }}
            children="Type:"
            component="p"
          >
            {types.map((typeObj) => {
              return typeObj.type.name;
            })}
          </Typography>
          <Button
            style={{ marginTop: "30px" }}
            fullWidth
            color="secondary"
            variant="contained"
            onClick={() => history.push("/")}
          >
            Back to Pokedex
          </Button>
        </Card>
      </>
    );
  };

  return (
    <>
      {PokemonData === undefined && (
        <CircularProgress
        thickness='6'
        color='secondary'
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%) translateX(-50%)",
          }}
        />
      )}
      {PokemonData !== undefined && PokemonData && generatePokemonJSX()}
      {PokemonData === false && (
        <>
          {" "}
          <Typography>Pokemon not found</Typography>{" "}
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push("/")}
          >
            Back to Pokedex
          </Button>{" "}
        </>
      )}
    </>
  );
};

export default Pokemon;
